import { gate } from 'hub-http/gates';
import { resolveIsUngated } from '../utilities/UserInfoHelper';
export const hasAllGates = gates => {
  const isUngated = resolveIsUngated();
  // eslint-disable-next-line hubspot-dev/no-bare-gate-strings
  return gates.every(g => isUngated(g) || isUngated(gate(g)));
};
export const NEW_ILS_TIME_FILTERS = 'new-ils-time-filters';
export const REMOVE_DEFAULT_VALUE_LOGIC = 'CRM:Filters:RemoveDefaultValue';
export const FILTERS_REMOVE_TIMEZONE_FOR_DATES = 'Filters:RemoveTimezoneForDateFilters';
export const hasNewIlsTimeFiltersEnabled = isUngated => {
  return isUngated(NEW_ILS_TIME_FILTERS);
};
export const hasRemoveTimezoneForDates = isUngated => {
  return isUngated(FILTERS_REMOVE_TIMEZONE_FOR_DATES);
};
export const CRM_SEARCH_X_DAYS_INCLUSIVE = gate('Filters:XDaysWithExclusiveBounds');
export const hasXDaysWithExclusiveBounds = isUngated => {
  return isUngated(CRM_SEARCH_X_DAYS_INCLUSIVE);
};
export const USE_IS_EXTERNAL_OPTIONS_PROPERTY = gate('Filters:UseIsExternalOptionsProperty');
export const hasUseIsExternalOptionsProperty = () => {
  return resolveIsUngated()(USE_IS_EXTERNAL_OPTIONS_PROPERTY);
};